import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createMessageAttachment, updateMessage } from './messages.service';
import { CreateMessageAttachmentBody, Message } from './messages.types';

export const useMessageUpdate = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({
      id,
      data,
      previousData,
    }: {
      id: string;
      data: Message;
      previousData: Message;
    }) => updateMessage({ id, data, previousData }),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['messages', 'infinite', variables.id], data);
      queryClient.invalidateQueries({
        queryKey: ['messages', 'infinite', variables.id],
      });
    },
    onError: (error) => {
      console.error('MessageFeedback Feedback submission error:', error);
    },
  });

  return mutation;
};

export const useMessageAttachmentCreate = () => {
  return useMutation({
    mutationFn: (data: CreateMessageAttachmentBody) =>
      createMessageAttachment(data),
  });
};
